function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiAnnualInsurance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.399,
    height: 58.652,
    viewBox: "0 0 56.399 58.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lxhnkwfjga"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2604",
    style: {
      fill: "#7bb564"
    },
    d: "M0 0h56.399v58.652H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19989",
    style: {
      clipPath: "url(#lxhnkwfjga)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29475",
    d: "M18.006 0h.8a1.838 1.838 0 0 1 1.23 2.183h6.526A1.829 1.829 0 0 1 27.744 0h.917a1.841 1.841 0 0 1 1.193 2.2h6.52A1.848 1.848 0 0 1 37.6 0h.8a1.8 1.8 0 0 1 1.295 2.194H46.2A1.823 1.823 0 0 1 47.447 0h.8A1.826 1.826 0 0 1 49.5 2.242c.567 0 1.079-.019 1.588 0a7.556 7.556 0 0 1 1.532.158 4.858 4.858 0 0 1 3.78 5.009q.009 20.155-.01 40.311a1.156 1.156 0 0 1-.294.741q-4.92 4.959-9.88 9.879a1.153 1.153 0 0 1-.736.3q-20.156.022-40.311-.009a5.7 5.7 0 0 1-2.371-.512A4.846 4.846 0 0 1 0 53.335Q.015 30.459.007 7.583c0-.3.006-.611.034-.915a4.857 4.857 0 0 1 4.471-4.376c.786-.051 1.578-.008 2.415-.008A1.83 1.83 0 0 1 8.154 0h.8a1.838 1.838 0 0 1 1.259 2.2H16.7A1.829 1.829 0 0 1 18 0M2.7 8.979c-.011.217-.027.4-.027.589v43.814a2.308 2.308 0 0 0 2.576 2.59q19.559.006 39.118 0a.92.92 0 0 0 1.008-1.021c.006-1.317-.027-2.636.02-3.951a3.466 3.466 0 0 1 3.288-3.347c1.314-.065 2.634-.03 3.951-.038.772 0 1.1-.329 1.1-1.1V9.573c0-.2-.017-.4-.026-.593z",
    style: {
      fill: "#7bb564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29476",
    d: "M12.926 47.853H8.978V37.728h3.948a5.046 5.046 0 0 1 5.38 5.034v.028a5.068 5.068 0 0 1-5.38 5.063m3.053-5.063a2.908 2.908 0 0 0-3.053-3.052H11.2v6.1h1.721a2.885 2.885 0 0 0 3.053-3.023z",
    transform: "translate(-.258 -1.087)",
    style: {
      fill: "#7bb564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29477",
    d: "m27.384 47.851-.926-2.271h-4.281l-.926 2.271H18.98l4.339-10.2h2.054l4.339 10.2zm-3.066-7.521-1.345 3.284h2.69z",
    transform: "translate(-.546 -1.084)",
    style: {
      fill: "#7bb564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29478",
    d: "M35.042 43.817v4.035h-2.227v-3.991l-3.891-6.133h2.6l2.415 4.064 2.461-4.064h2.531z",
    transform: "translate(-.833 -1.087)",
    style: {
      fill: "#7bb564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29479",
    d: "M43.714 47.992a6.444 6.444 0 0 1-4.3-1.62l1.32-1.572a4.646 4.646 0 0 0 3.022 1.23c.911 0 1.462-.361 1.462-.955v-.029c0-.563-.347-.853-2.039-1.287-2.041-.521-3.357-1.085-3.357-3.1v-.029c0-1.838 1.475-3.053 3.545-3.053a5.856 5.856 0 0 1 3.76 1.289l-1.157 1.678a4.747 4.747 0 0 0-2.633-1c-.852 0-1.3.39-1.3.883v.028c0 .666.435.882 2.184 1.331 2.055.535 3.211 1.273 3.211 3.038v.029c0 2.01-1.533 3.138-3.717 3.138",
    transform: "translate(-1.135 -1.082)",
    style: {
      fill: "#7bb564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29480",
    d: "M9.122 19.373v-2.842h10.185v2.5l-3.812 3.639c2.068.344 4.049 1.42 4.049 4.241 0 2.864-2.067 4.952-5.426 4.952a7.313 7.313 0 0 1-5.879-2.6l2.282-2.176a4.6 4.6 0 0 0 3.639 1.809 1.894 1.894 0 0 0 2.132-1.851c0-1.25-1.056-1.94-2.95-1.94h-1.377l-.517-2.109 3.6-3.618z",
    transform: "translate(-.237 -.476)",
    style: {
      fill: "#7bb564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29481",
    d: "M31.941 20.485a4.638 4.638 0 0 0-3.079-1.206c-1.874 0-2.821 1.507-3.037 3.488a5.216 5.216 0 0 1 3.122-.968c2.993 0 5.3 1.658 5.3 4.823 0 3.1-2.477 5.233-5.749 5.233a5.72 5.72 0 0 1-4.35-1.615c-1.1-1.1-1.787-2.713-1.787-5.728 0-4.672 2.11-8.247 6.611-8.247a6.985 6.985 0 0 1 4.715 1.658zm-3.618 4.069c-1.636 0-2.583.9-2.583 2.2 0 1.312.99 2.26 2.626 2.26s2.584-.926 2.584-2.24c0-1.292-.991-2.217-2.627-2.217",
    transform: "translate(-.644 -.469)",
    style: {
      fill: "#7bb564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29482",
    d: "M38.231 16.531h9.259v2.906h-6.417l-.173 2.607a7.379 7.379 0 0 1 1.981-.259c2.972 0 5.276 1.422 5.276 4.844 0 3.209-2.261 5.233-5.728 5.233a7.753 7.753 0 0 1-5.641-2.262l2-2.39a5.275 5.275 0 0 0 3.6 1.637c1.55 0 2.519-.755 2.519-2.11 0-1.314-1.055-2.068-2.67-2.068a6.458 6.458 0 0 0-2.519.56l-1.918-1.27z",
    transform: "translate(-1.059 -.476)",
    style: {
      fill: "#7bb564"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiAnnualInsurance);
export default __webpack_public_path__ + "static/media/tiAnnualInsurance.acc625ec578704e791f1f6b222fc1d99.svg";
export { ForwardRef as ReactComponent };